/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  new WOW().init();

  jQuery(".sp-scroll").slide({
    mainCell: ".nav-imgs",
    autoPlay: true,
    effect: "leftMarquee",
    interTime: 12,
    vis: 1,
    scroll: 1,
  });

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 4500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })
  
  new Swiper(".sp-swiper1", {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination",
      clickable: true,
    },
  });

  // 初始化所有 sp-swiper2 实例并绑定对应的按钮
  const swiper2Elements = document.querySelectorAll(".sp-swiper2");
  swiper2Elements.forEach((swiperEl, index) => {
    // 为每个swiper创建实例
    const swiper2Instance = new Swiper(swiperEl, {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: swiperEl.querySelector(".sp-pagination"),
        clickable: true,
      },
    });

    // 找到这个swiper所在的父容器
    const container = swiperEl.closest('.sp-mobile, .sp-pc');
    if (container) {
      // 绑定该容器内的切换按钮
      const prevBtn = container.querySelector(".sp-swiper-btn-prev");
      const nextBtn = container.querySelector(".sp-swiper-btn-next");
      
      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          swiper2Instance.slidePrev();
          console.log('上一张被点击');
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          swiper2Instance.slideNext();
          console.log('下一张被点击');
        });
      }
    }
  });

  new Swiper(".sp-swiper-fade", {
    spaceBetween: 10,
    effect: "fade",
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  });

  new Swiper(".sp-swiper-fade1", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
    on: {
      slideChange: function (e) {
        e.slides.find(".sp-text").each(function () {
          this.style.animation = "none";
        });
        const spText = e.slides.eq(e.activeIndex).find(".sp-text")[0];
        if (spText) {
          spText.style.animation = "none";

          spText.style.animation = `swiper-up-fade 0.5s ease forwards`;
        }
      },
    },
  });

  new Swiper(".sp-swiper0", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 10,
    loop: true,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080;
        $("#root").css("zoom", scale);
      } else {
        const scale = document.body.clientWidth / 1920;
        $("#root").css("zoom", scale);
      }

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080;
                $("#root").css("zoom", scale);
              } else {
                const scale = document.body.clientWidth / 1920;
                $("#root").css("zoom", scale);
              }
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    
    
    // 准备图片数组 - 状态1的图片（sh1）- 移动端
    let imgListState1Mobile = [
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p1.png',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p2.png?v=1787819809',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p4.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p5.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p6.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p7.jpg',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/3c7e09d3117f1d019ee6f670933de1890f7fdc63_bd3892d4-7bfe-41dc-9af2-e3acc06ff2b4.png?v=1787819701&width=1946',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p3.png?v=1787819809',
    ];
    // for (let i = 1; i <= 10; i++) {
    //   imgListState1Mobile.push(`https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p${i}.png`);
    // }
    
    // 准备图片数组 - 状态2的图片（sh2）- 移动端
    let imgListState2Mobile = [];
    for (let i = 1; i <= 10; i++) {
    }
    
    // 准备图片数组 - 状态1的图片（sh1）- PC端
    let imgListState1PC = [
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p4.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p5.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p6.jpg',
      'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p7.jpg',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p1.png',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p2.png?v=1787819809',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/3c7e09d3117f1d019ee6f670933de1890f7fdc63_bd3892d4-7bfe-41dc-9af2-e3acc06ff2b4.png?v=1787819701&width=1946',
    //   'https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p3.png?v=1787819809',
    ];
    // for (let i = 1; i <= 10; i++) {
    //   imgListState1PC.push(`https://cdn.shopify.com/s/files/1/0618/4150/6441/files/20251209-p${i}.png`);
    // }
    
    // 准备图片数组 - 状态2的图片（sh2）- PC端
    let imgListState2PC = [];
    for (let i = 1; i <= 10; i++) {
    }
    
    // 预加载所有图片
    preloadImages([...imgListState1Mobile, ...imgListState2Mobile, ...imgListState1PC, ...imgListState2PC]);
    
    // 套餐状态：true=状态1（默认），false=状态2
    let comboStateMobile = true;
    let comboStatePC = true;
    
    // 数量文本数组
    let qtyTexts = ['x 10pcs', 'x 30pcs', 'x 50pcs'];
    
    // 更新主图显示 - 移动端
    function updateMainImageMobile() {
      let colorIndex = $(".sp-mobile .sp-type .sp-option.active").index();
      let qtyIndex = $(".sp-mobile .sp-qty .sp-option.active").index();
      let currentImgList = comboStateMobile ? imgListState1Mobile : imgListState2Mobile;
      
      // 隐藏所有图片
      $(".product-part.sp-mobile .sp-img-p").removeClass("active");
      
      // 显示对应的图片
      if (comboStateMobile) {
        $(".product-part.sp-mobile .sp-img-p").eq(0).addClass("active").attr('src', currentImgList[qtyIndex]);
      } else {
        $(".product-part.sp-mobile .sp-img-p").eq(1).addClass("active").attr('src', currentImgList[qtyIndex]);
      }
    }
    
    // 更新主图显示 - PC端
    function updateMainImagePC() {
      let colorIndex = $(".sp-pc .sp-type .sp-option.active").index();
      let qtyIndex = $(".sp-pc .sp-qty .sp-option.active").index();
      let currentImgList = comboStatePC ? imgListState1PC : imgListState2PC;
      
      // 隐藏所有图片
      $(".product-part.sp-pc .sp-img-p").removeClass("active");
      
      // 显示对应的图片
      if (comboStatePC) {
        $(".product-part.sp-pc .sp-img-p").eq(0).addClass("active").attr('src', currentImgList[qtyIndex]);
      } else {
        $(".product-part.sp-pc .sp-img-p").eq(1).addClass("active").attr('src', currentImgList[qtyIndex]);
      }
    }

    // 颜色选项点击事件 - 移动端
    $(".sp-mobile .sp-type .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      updateMainImageMobile();
      changePrice1();
    });
    
    // 颜色选项点击事件 - PC端
    $(".sp-pc .sp-type .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      updateMainImagePC();
      changePrice2();
    });
    
    // 数量选项点击事件 - 移动端
    $(".sp-mobile .sp-qty .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      let qtyIndex = $(this).index();
    //   let textArr = [1,3,5]
    //   if (qtyIndex == 0){
    //       $('.product-part.sp-mobile .sp-number').hide();
    //   }else{
    //       $('.product-part.sp-mobile .sp-number').show();
    //       $('.product-part.sp-mobile .sp-number').text('X' + Number(textArr[qtyIndex]))
    //   }
      updateMainImageMobile();
      changePrice1();
    });
    
    // 数量选项点击事件 - PC端
    $(".sp-pc .sp-qty .sp-option").click(function () {
      $(this).siblings().removeClass("active");
      $(this).addClass("active");
      
      let qtyIndex = $(this).index();
      let textArr = [1,3,5]
    //   if (qtyIndex == 0){
    //       $('.product-part.sp-pc .sp-number').hide();
    //   }else{
    //       $('.product-part.sp-pc .sp-number').show();
    //       $('.product-part.sp-pc .sp-number').text('X' + Number(textArr[qtyIndex]))
    //   }
      updateMainImagePC();
      changePrice2();
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  // 找到所有跳转套餐的锚点链接 - 使用事件委托确保所有链接都能工作
  function handleShoppingLinkClick(event) {
    // 检查是否是指向#shopping的链接
    const link = event.target.closest('a[href="#shopping"]');
    if (!link) return;
    
    event.preventDefault(); // 阻止默认的跳转行为
    console.log('Shopping链接被点击'); // 调试信息
    
    // 检查是否是sp-part3中的按钮（Buy 3 get 2 free按钮）
    const isInPart3 = link.closest('.sp-part3');
    if (isInPart3) {
      console.log('检测到sp-part3中的按钮，自动选中50 Pcs'); // 调试信息
      // 选中50 Pcs选项（第三个选项，索引为2）
      setTimeout(function() {
        $(".sp-mobile .sp-qty .sp-option").removeClass("active");
        $(".sp-mobile .sp-qty .sp-option").eq(2).addClass("active");
        // 更新数量文本
        $(".sp-mobile .sp-title1").text('x 50pcs');
        
        // PC端也更新
        $(".sp-pc .sp-qty .sp-option").removeClass("active");
        $(".sp-pc .sp-qty .sp-option").eq(2).addClass("active");
        $(".sp-pc .sp-title1").text('x 50pcs');
      }, 500);
    }
    
    // 执行跳转
    const targetElement = document.getElementById("shopping");
    if (targetElement) {
      const offsetTop = targetElement.offsetTop;
      let sptop = document.body.clientWidth <= 1080 ? 350 : 40;
      
      // 获取zoom值，如果不存在则默认为1
      let zoomValue = parseFloat($("div#root").css("zoom")) || 1;
      
      const scrollTop = offsetTop * zoomValue - sptop * zoomValue;

      // 尝试多种滚动方式以确保兼容性
      // 方式1: 使用window.scrollTo
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
      
      // 方式2: 如果方式1不工作，直接设置scrollTop（兼容性更好）
      setTimeout(() => {
        if (window.pageYOffset === 0 || Math.abs(window.pageYOffset - scrollTop) > 100) {
          $('html, body').animate({
            scrollTop: scrollTop
          }, 800);
        }
      }, 100);
      
      console.log('跳转到shopping区域, offsetTop:', offsetTop, 'zoom:', zoomValue, 'sptop:', sptop, 'scrollTop:', scrollTop);
    } else {
      console.log('未找到shopping元素');
    }
  }
  
  // 使用事件委托在document上监听所有点击
  document.addEventListener('click', handleShoppingLinkClick);

  let sp_price1 = 24.99;
  let sp_price2 = 29.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  let prods = window.product
  function getCur1() {
    let type = $('.sp-mobile #sp-type div.active').attr('data-val')
    let qty = $('.sp-mobile #sp-qty div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == type && item.option2 == qty 
    )[0]
  }
  function getCur2() {
    let type = $('.sp-pc #sp-type div.active').attr('data-val')
    let qty = $('.sp-pc #sp-qty div.active').attr('data-val')
    return prods.filter(
      item => item.option1 == type && item.option2 == qty 
    )[0]
  }
  function changePrice1() {
    let num = $('.sp-mobile #calcNumber').val()
    let price = ((getCur1().price * num) / 100).toFixed(2)
    let compare = ((getCur1().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.sp-mobile #sp_price1 span').html(price)
    $('.sp-mobile #sp_price2 span').html(compare)

    let off_font =
      100 - Math.ceil((getCur1().price / getCur1().compare_at_price) * 100)
    $('.sp-mobile.product-part .price-group .off-font').html(off_font)
  }
  function changePrice2() {
    let num = $('.sp-pc #calcNumber').val()
    let price = ((getCur2().price * num) / 100).toFixed(2)
    let compare = ((getCur2().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $('.sp-pc #sp_price1_pc span').html(price)
    $('.sp-pc #sp_price2_pc span').html(compare)

    let off_font =
      100 - Math.ceil((getCur2().price / getCur2().compare_at_price) * 100)
    $('.sp-pc.product-part .price-group .off-font').html(off_font)
  }
  $('.sp-mobile .sp-btn-style').click(function () {
    let num = $('.sp-mobile #calcNumber').val()
    window.location.href = '/cart/' + getCur1().id + ':' + num
  })
  $('.sp-pc .sp-btn-style').click(function () {
    let num = $('.sp-pc #calcNumber').val()
    window.location.href = '/cart/' + getCur2().id + ':' + num
  })
  $(".sp-mobile .sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice1()
  });
  $(".sp-mobile .sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice1()
  });

  $(".sp-pc .sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice2()
  });
  $(".sp-pc .sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice2()
  });

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span, div");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span/div 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $(".sp-menu-btn").click(function (e) {
    $(".sp-menu-mask").show();
  });

  $(".sp-menu-mask").click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $(".sp-menu-mask").hide();
    // }
  });

  // // 滚动添加底部
  // if (
  //   $(window).scrollTop() >
  //   $(".sp-part1").height() * $("div#root").css("zoom") -
  //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
  // ) {
  //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
  // } else {
  //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
  // }

  $(window).scroll(function () {

    // if (
    //   $(window).scrollTop() >
    //   $(".sp-part1").height() * $("div#root").css("zoom") -
    //     $(".sp-part1 .swiper").height() * $("div#root").css("zoom")
    // ) {
    //   $(".sp-btn-style2").addClass("sp-fixed-bottom");
    // } else {
    //   $(".sp-btn-style2").removeClass("sp-fixed-bottom");
    // }
  });

  $(function () {
    // 购物车加购动效
    $(".sp-mobile .cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-mobile .sp-cart .num").show();
      setTimeout(function () {
        $(".sp-mobile .cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-mobile .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-mobile .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;

    $(".product-part.sp-mobile .cart-btn").click(function () {
      var data = {
        id: getCur1().id,
        quantity: $('.sp-mobile #calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");
            });
          })
        },
        dataType: 'json',
      })

      // var imgs = $(".product-part .swiper-slide-active").find("img");
      var imgs = $(".product-part.sp-mobile .sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part.sp-mobile").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",

          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish = $(".sp-btn-style2.sp-mobile .sp-cart");

        $(flyer).animate(
          {
            top: $(".sp-btn-style2")[0].offsetTop,
            left:
              $(".sp-btn-style2 .sp-area2")[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // PC
  $(function () {
    // 购物车加购动效
    $(".sp-pc .cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-pc .sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".sp-pc .cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-pc .sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-pc .sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part.sp-pc .cart-btn").click(function () {
      var data = {
        id: getCur2().id,
        quantity: $('.sp-pc #calcNumber').val(),
      }
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
            $(".cardNum").each(function () {
                $(this).html(result.item_count);
                $(this).removeClass("sp-gray");
            });
          })
        },
        dataType: 'json',
      })

      // var imgs = $(".product-part .swiper-slide-active").find("img");
      var imgs = $(".product-part.sp-pc .sp-img-p.active");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(".product-part.sp-pc").append(flyer);
        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",

          top: $img[0].offsetTop,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish = $(".sp-pc .sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });

  // 问答
  $(".q-row").click(function () {
    $(this).parent().toggleClass("sp-show");
  });

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName("sp-fade-box");
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll(".sp-ani");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`;
              span.style.animationDelay = `${index * 0.5 + 0.5}s`;
            });

            observerAni.unobserve(gradually2);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually2);
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName("sp-fade-box2");
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll(".sp-ani2");

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`;
              span.style.animationDelay = `${index * 0.3 + 1}s`;
            });

            observerAni.unobserve(gradually3);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observerAni.observe(gradually3);
  }
});
